import { ca } from '@cian/analytics';

export const trackMortgageBannerClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_banner',
    page: {
      extra: {
        trap_type: 'skidki_i_akcii_mortgage_percents',
        bannerName: 'Заполнить анкету',
        trapid: 'Заполнить анкету',
      },
    },
  });
};
